import { ResponsiveStyleValue } from '@styled-system/css'
import styled from 'styled-components'
import {
  color,
  ColorProps,
  compose,
  flexbox,
  FlexboxProps,
  layout,
  LayoutProps,
  space,
  SpaceProps,
  variant,
} from 'styled-system'

import { defaultConfig } from '../../extensions'
import { transition, TransitionProps } from '../../transition'
import { whiteSpace, WhiteSpaceProps } from '../typography'
import { Button, ButtonProps } from './Button'
import {
  buttonDisabledVariants,
  ButtonLayoutProps,
  buttonLayoutVariant,
  buttonLoadingVariants,
  buttonStateMapping,
  defaultButtonStyles,
} from './variants'

export type SecondaryButtonProperty = 'default' | 'inverted'

export interface SecondaryButtonProps
  extends ButtonProps,
    ButtonLayoutProps,
    LayoutProps,
    SpaceProps,
    ColorProps,
    TransitionProps,
    WhiteSpaceProps,
    FlexboxProps {
  variant?: ResponsiveStyleValue<SecondaryButtonProperty>
}

export const SecondaryButton = styled(Button)
  .withConfig(defaultConfig)
  .attrs(buttonStateMapping)<SecondaryButtonProps>(
  defaultButtonStyles,
  variant({
    scale: 'SecondaryButton.variants',
    variants: {
      default: {
        bg: 'secondaryAccent',
        color: 'chalk',
      },
      inverted: {
        bg: 'chalk',
        color: 'secondaryAccent',
      },
    },
  }),
  variant({
    prop: 'loadingState',
    scale: 'SecondaryButton.loading',
    variants: buttonLoadingVariants,
  }),
  variant({
    prop: 'disabledState',
    scale: 'SecondaryButton.disabled',
    variants: buttonDisabledVariants,
  }),
  buttonLayoutVariant,
  compose(layout, space, color, transition, whiteSpace, flexbox),
)

SecondaryButton.defaultProps = {
  variant: 'default',
  layout: 'default',
}
